import { useRouter } from "vue-router";

import { logout as logoutRequest } from "@/api/auth";

import ls from "@/services/local-storage";
import { useAuthStore } from "@/stores/auth.store";

export const useLogout = () => {
  const authStore = useAuthStore();
  const router = useRouter();

  const logout = (expired = false) => {
    logoutRequest().catch(() => undefined);
    ls.clearToken();
    authStore.clearLoggedIn();
    router.replace({
      name: "login",
      ...(expired && { query: { session_expired: "true" } })
    });
  };

  return { logout };
};
